import React from "React";

type DataProps = {
	category: string;
	logo: string;
	name: string;
};
const TechnologyItem: React.FC<DataProps> = (props) => {
	return (
		<div className=' thick-shadow p-5 m-5 w-full max-w-xs '>
			<div className='flex self-center items-center flex-col w-full'>
				<div>
					<img
						style={{
							maxWidth: "80px",
						}}
						src={props.logo}
					/>
				</div>
				<div>
					<div className='text-sm -mb-2 text-left'>
						#{props.category}
					</div>
					<div className='text-3xl text-center'>{props.name}</div>
					<div className='border-bottom'></div>
				</div>
			</div>
		</div>
	);
};

export default TechnologyItem;
